import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapActions } from 'vuex';
import Icon from '@comp/Icon.vue';
import UserAvatar from '@comp/base/UserAvatar.vue';
import FollowButton from '@comp/parts/FollowButton.vue';
import UserFollowersIcon from '!!url-loader?!@static/icons/user-followers.svg';
import UsersIcon from '!!url-loader?!@static/icons/s-users.svg';
import JobIcon from '!!url-loader?!@static/icons/s-job.svg';
import UniversityIcon from '!!url-loader?!@static/icons/s-university.svg';
import MapIcon from '!!url-loader?!@static/icons/s-map.svg';
import BlockUserButton from '@comp/parts/BlockUserButton.vue';
import { BLOCKING_STATUSES } from '@utils/constants';
export default {
  name: 'UserCard',
  components: {
    Icon: Icon,
    UserAvatar: UserAvatar,
    FollowButton: FollowButton,
    BlockUserButton: BlockUserButton
  },
  props: {
    photoUrl: String,
    firstName: String,
    lastName: String,
    userName: {
      type: String,
      required: true
    },
    followersCount: {
      type: Number,
      required: true
    },
    mutualFollowersCount: {
      type: Number,
      required: true
    },
    blockingStatus: String,
    followingStatus: String,
    followLoading: Boolean,
    statistics: {
      type: Object,
      required: true
    },
    suggestedReason: String,
    job: {
      type: String,
      default: null
    },
    position: {
      type: String,
      default: null
    },
    university: {
      type: String,
      default: null
    },
    address: {
      type: String,
      default: null
    },
    leaderBoardPosition: Number,
    hotBoardPosition: Number,
    goToProfileIfUnathorized: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      UserFollowersIcon: UserFollowersIcon,
      JobIcon: JobIcon,
      UniversityIcon: UniversityIcon,
      MapIcon: MapIcon,
      UsersIcon: UsersIcon
    };
  },
  BLOCKING_STATUSES: BLOCKING_STATUSES,
  computed: _objectSpread(_objectSpread({}, mapState('userBlocking', {
    usersBlockingState: function usersBlockingState(state) {
      return state.byUserName;
    }
  })), {}, {
    getBlockingStatus: function getBlockingStatus() {
      return (this.usersBlockingState[this.userName] || {}).status || this.blockingStatus;
    },
    isBlocking: function isBlocking() {
      return !!(this.usersBlockingState[this.userName] || {}).loading;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions('userBlocking', ['unblock'])), {}, {
    goToUser: function goToUser() {
      if (this.$store.getters['auth/isAuthenticated'] || this.goToProfileIfUnathorized) {
        this.$router.push({
          name: 'UserPage',
          params: {
            userName: this.userName
          }
        });
      } else {
        this.$store.commit('auth/setAuthPopup', {
          show: true
        });
      }
    },
    followHandler: function followHandler() {
      if (this.$store.getters['auth/isAuthenticated']) {
        this.$emit('follow');
      } else {
        this.$store.commit('auth/setAuthPopup', {
          show: true
        });
      }
    },
    unfollowHandler: function unfollowHandler() {
      if (this.$store.getters['auth/isAuthenticated']) {
        this.$emit('unfollow');
      } else {
        this.$store.commit('auth/setAuthPopup', {
          show: true
        });
      }
    }
  })
};